module.exports = __webpack_public_path__ + "static/media/agalerija_2023 (38).f12e7ac3.png";